import React from 'react'
import PropTypes from 'prop-types'

const ChevronBoldIcon = ({ fill }) => (
    <svg version="1.1" baseProfile="tiny" fill={fill || '#010C3A'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" xmlSpace="preserve">
          <path d="M13.75 22.987l-7.99-9c-.51-.57-.76-1.28-.76-1.99s.25-1.42.74-1.98c.01 0 .01-.01.01-.01l.02-.02 7.98-8.98c1.1-1.24 3.002-1.35 4.242-.25 1.24 1.1 1.35 3 .25 4.23l-6.23 7.01 6.23 7.01c1.1 1.24.99 3.13-.25 4.24-1.24 1.1-3.13.98-4.24-.26z"/>
    </svg>

)

ChevronBoldIcon.propTypes = {
    fill: PropTypes.string,
}

export default ChevronBoldIcon